import { closeModal } from "app/slices/modalSlice";
import { useTranslation } from "react-i18next";
import { Button } from "components/Shared";
import { useDispatch } from "react-redux";
import { IDestinationBankAccountAll } from "interfaces";
import {
  DestinationBankAccountClassName,
  TransactionTypeOptions,
} from "interfaces/enums";
import Truncator from "components/Shared/truncator";
import { emptyValue } from "utils";
import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const Label = ({ label, value }: { label: string; value: any }) => {
  return (
    <div className="grid grid-cols-2">
      <p className=" font-lader">{label}</p>
      <Truncator maxLength={24}>{value}</Truncator>
    </div>
  );
};

export const ViewBankAccountModal = ({
  data,
}: {
  data: IDestinationBankAccountAll;
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const destinationAccount = () => {
    if (data.class_name === DestinationBankAccountClassName.SPID) {
      return (
        <>
          <Label label={t("Recipient's Name")} value={data?.recipient_name} />
          <Label
            label={t("Transfer Type")}
            value={
              data?.class_name
                ? TransactionTypeOptions[data?.class_name]
                : emptyValue
            }
          />
          <Label label={t("Bank Name")} value={data?.bank_name} />
          <Label label={"CLABE"} value={data?.clabe_dest} />
          <Label label={t("Recipient's RFC")} value={data?.rfc_dest} />
          <Label
            label={t("Recipient's Address")}
            value={data?.address_dest || emptyValue}
          />
        </>
      );
    } else if (
      data.class_name === DestinationBankAccountClassName.UsDomesticWire
    ) {
      return (
        <>
          <Label label={t("Recipient's Name")} value={data?.recipient_name} />
          <Label
            label={t("Transfer Type")}
            value={
              data?.class_name
                ? TransactionTypeOptions[data?.class_name]
                : emptyValue
            }
          />
          <Label label={t("Bank Name")} value={data?.bank_name} />
          <Label label={t("Account Number")} value={data?.acct_number_dest} />
          <Label label={t("Routing Number")} value={data?.routing_dest} />
          <Label
            label={t("Recipient's Address")}
            value={data?.address_dest || emptyValue}
          />
          <Label label={t("Bank's Address")} value={data?.bank_address} />
        </>
      );
    } else if (
      data.class_name === DestinationBankAccountClassName.CryptoWallet
    ) {
      return (
        <>
          <Label label={t("Alias")} value={data?.alias} />
          <Label
            label={t("Transfer Type")}
            value={
              data?.class_name
                ? TransactionTypeOptions[data?.class_name]
                : emptyValue
            }
          />
          <Label label={t("Network")} value={data?.network} />
          <Label label={t("Wallet Address")} value={data?.wallet_address} />
        </>
      );
    }
  };

  return (
    <DialogContent className="max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>{t("Destination Account Details")}</DialogTitle>
      </DialogHeader>
      {destinationAccount()}
      <Label label={t("Email")} value={data?.email || emptyValue} />
      <DialogFooter>
        <Button onClick={handleClose}>{t("Close")}</Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default ViewBankAccountModal;
